import React from 'react';

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum saepe
        quae, optio voluptates voluptatum voluptas explicabo, iste, aliquid
        quidem reiciendis distinctio doloribus odio architecto beatae labore
        nostrum rerum? Perferendis minus sed porro. A dolores doloremque tempora
        eligendi blanditiis dolor quisquam.
      </p>
    </section>
  );
};

export default About;
